import { isUndefinedOrNull } from "../../../../omnia"
import { FertiliserAppUnit, IAppZoneUpdateModel, INtrApp, INutrient, NutrientType } from "../../../../types"
import { DefaultNeutralisingValue } from "../../../../utils"

export class AppZoneVm {

    static createZones(app: INtrApp[], unit: FertiliserAppUnit, watcher: (zone: AppZoneVm) => void) {

        return app.map(a => new AppZoneVm(a, unit, watcher)).sort((a1, a2) => a1.zoneNumber - a2.zoneNumber)

    }

    private _area: number

    private _productRate: number
    private _userDefined: boolean


    constructor(private readonly app: INtrApp, private readonly unit: FertiliserAppUnit, private readonly watcher: (zone: AppZoneVm) => void) {

        this._area = Math.round(app.Area / 1000) / 10
        this._productRate = app.ProductRate
        this._userDefined = app.UserDefined

        this.watcher = watcher || (z => { })

    }


    get id() {
        return this.app.NtrAppId
    }

    get croppingId() {
        return this.app.CroppingId
    }

    get appId() {
        return this.app.AppId
    }

    get zoneNumber() {
        return this.app.ZoneNumber
    }

    get area() {
        return this._area
    }

    get productRate() {
        return this._productRate
    }

    set productRate(value: number) {
        this._productRate = value
        this._userDefined = (value != this.initProductRate)
        this.watcher(this)
    }

    get initProductRate(): number {
        if (this.app) {
            return this.app.UserDefined ? this.app.InitProductRate : this.app.ProductRate
        }
    }

    get userDefined(): boolean {
        return this._userDefined
    }

    reset() {
        this._productRate = this.initProductRate
        this._userDefined = false
        this.watcher(this)
    }

    cancelChanges() {
        this.productRate = this.app.ProductRate
        this._userDefined = this.app.UserDefined
        this.watcher(this)
    }

    contributesNutrient(nutrient: INutrient) {

        if (nutrient.nutrient == NutrientType.Lime) {
            return !!this.app.NeutralisingValue
        }

        let key = nutrient.key + "Analysis"
        let a = this.app[key]
        return !!a

    }

    getNutrientRate(nutrient: INutrient) {

        if (this.hasChanged()) {

            const { unit, productRate, app } = this

            if (isUndefinedOrNull(productRate)) {
                return undefined
            }

            let multiplier = 1
            let limeMultiplier = 1

            switch (unit) {

                case FertiliserAppUnit.T:
                case FertiliserAppUnit.M3:
                    multiplier = 1000
                    break

                case FertiliserAppUnit.Kg:
                case FertiliserAppUnit.L:
                    limeMultiplier = 1
                    break

            }

            let nutrientRate = (nutrient.nutrient == NutrientType.Lime)
                ? limeMultiplier * (app.NeutralisingValue / DefaultNeutralisingValue)
                : multiplier * app[nutrient.key + "Analysis"]

            return Math.round(productRate * nutrientRate)

        }

        return this.app[nutrient.key]

    }

    hasChanged(): boolean {
        const { app, _productRate, _userDefined } = this
        const changed = app && ((_productRate != app.ProductRate) || (!!_userDefined != !!app.UserDefined))
        return changed
    }

    getUpdateModel(): IAppZoneUpdateModel {
        return {
            NtrAppId: this.app.NtrAppId,
            PlanId: this.app.PlanId,
            AppId: this.app.AppId,
            CroppingId: this.app.CroppingId,
            ProductRate: this.productRate,
            UserDefined: this.userDefined,
        }
    }
}
